import { cn } from "@/lib/tailwind"
import type * as React from "react"

interface Props extends React.SVGProps<SVGSVGElement> {
  isSelected?: boolean
  fillClassName?: string
  size?: number
}

export function RegionsIcon({ isSelected, size, fillClassName, fill, ...props }: Props) {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      width={size || "16px"}
      height={size || "16px"}
      viewBox="0 0 16 16"
      className="fill-black dark:fill-white"
      {...props}
    >
      <title>Regions</title>
      {isSelected ? (
        <path
          d="m8,0C4.58,0,1.79,2.79,1.79,6.21c0,3.19,1.93,6.36,5.89,9.67.09.08.21.12.32.12s.23-.04.32-.12c3.96-3.32,5.89-6.49,5.89-9.67,0-3.42-2.79-6.21-6.21-6.21Zm2.08,6.24c0,1.2-.98,2.18-2.19,2.18s-2.18-.98-2.18-2.18.98-2.19,2.18-2.19,2.19.98,2.19,2.19Z"
          className={cn(fill ? "" : fillClassName || "fill-primary-500")}
          fill={fill}
        />
      ) : (
        <>
          <path d="m7.89,4.37c-1.03,0-1.87.84-1.87,1.87s.84,1.87,1.87,1.87,1.87-.84,1.87-1.87-.84-1.87-1.87-1.87Z" fill="none" />
          <path
            d="m8,1c-2.87,0-5.21,2.34-5.21,5.21s1.71,5.62,5.21,8.63c3.51-3.01,5.21-5.84,5.21-8.63S10.87,1,8,1Zm-.11,8.11c-1.58,0-2.87-1.29-2.87-2.87s1.29-2.87,2.87-2.87,2.87,1.29,2.87,2.87-1.29,2.87-2.87,2.87Z"
            fill="none"
          />
          <path d="m8,0C4.58,0,1.79,2.79,1.79,6.21c0,3.19,1.93,6.36,5.89,9.67.09.08.21.12.32.12s.23-.04.32-.12c3.96-3.32,5.89-6.48,5.89-9.67,0-3.42-2.79-6.21-6.21-6.21Zm0,14.84c-3.5-3.01-5.21-5.84-5.21-8.63S5.13,1,8,1s5.21,2.34,5.21,5.21-1.71,5.62-5.21,8.63Z" />
          <path d="m7.89,3.37c-1.58,0-2.87,1.29-2.87,2.87s1.29,2.87,2.87,2.87,2.87-1.29,2.87-2.87-1.29-2.87-2.87-2.87Zm0,4.74c-1.03,0-1.87-.84-1.87-1.87s.84-1.87,1.87-1.87,1.87.84,1.87,1.87-.84,1.87-1.87,1.87Z" />
        </>
      )}
    </svg>
  )
}
